module.exports = __webpack_public_path__ + "img/certificate-15a.5f9742c8.jpg";